import React from "react";

import { SYSTEM_ADMIN_PATH } from "../../../../../constants";

const Profile = React.lazy(() => import('../../Profile'));

const routes = {
     path: SYSTEM_ADMIN_PATH.PROFILE,
     breadcrumb: 'Profile',
     element: <Profile />
};

export default routes;
